import React from "react";
import RouteMaster from "../../components/master/RouteMaster";
import PageLayout from "../../components/PageLayout";

interface MasterPageProps {
  onLogout?: () => void;
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

const RouteMasterPage: React.FC<MasterPageProps> = ({ onLogout, currentPage, onNavigate }) => {
  return (
    <PageLayout onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate}>
      <RouteMaster />
    </PageLayout>
  );
};

export default RouteMasterPage;
